import { AddressFields, PersonalInfoFields, PersonFields } from '../../models/form-models';

export const MaritalStatusPersonFieldsRequiredSchema: PersonFields = {
    first_name: true,
    middle_name: false,
    last_name: true,
    gender: false,
    gender_identity: false,
    gender_identity_other: false,
    suffix: false,
    date_of_birth: false,
    tax_id: false,
};

export const MaritalStatusMailingAddressRequiredSchema: AddressFields = {
    country: false,
    address1: false,
    address2: false,
    address3: false,
    city: false,
    state: false,
    postalCode: false,
};

export interface MaritalStatusFormValues extends PersonalInfoFields {
    marital_status: string;
    marital_status_effective_date: string;

    marriage_end_date?: string;

    // spouse info
    designation_salutation: string;
    

    // address
    mailing_address_1: string;
    mailing_address_2: string;
    mailing_address_3: string;
    mailing_country: string;
    mailing_city: string;
    mailing_state: string;
    mailing_postal_code: string;

    // phones
    business_phone_country_code: string;
    business_phone_area_code: string;
    business_phone_number: string;
    business_phone_formated:  string;
    business_phone_extension: string;

    home_phone_country_code: string;
    home_phone_area_code: string;
    home_phone_number: string;
    home_phone_formated: string;
    home_phone_extension: string;

    mobile_phone_country_code: string;
    mobile_phone_area_code: string;
    mobile_phone_number: string;
    mobile_phone_formated: string;
    mobile_phone_extension: string;

    personal_email_address: string;
    office_email_address: string;

    matched_person: string;
    attestation1: boolean;
    attestation2: boolean;
    court_issuing: string | null;
    case_number: number | null;
}